module.exports = "/_next/static/images/hand-20589ef133b44f11a672fb14411bb81f.svg";